import React from 'react'
import Footer from '../footer/footer'
import StudyGer from './StudyGer'

function StudyAtCa() {
  return (
    <div>
    <StudyGer
    title="Canada"/>
    <Footer/>
    </div>
  )
}

export default StudyAtCa